/**
 * @typedef {Object} PurchaseOrderCreateDto
 * @property {number} supplierId
 * @property {number} deliveryWarehouseId
 * @property {string} [expectedDeliveryDate]
 * @property {string} [currency]
 * @property {string} [paymentTerms]
 * @property {string} [shippingMethod]
 * @property {string} [billingAddress]
 * @property {string} [shippingAddress]
 * @property {string} [notes]
 */

/**
 * @typedef {Object} PurchaseOrderLineCreateDto
 * @property {number} [componentId] - exactly one of componentId/boxId must be set
 * @property {number} [boxId]
 * @property {number} quantityOrdered
 * @property {number} unitPrice
 * @property {string} [expectedDeliveryDate]
 * @property {string} [notes]
 */

/**
 * @typedef {Object} PurchaseOrderReceiveLineDto
 * @property {number} quantityReceived
 * @property {number} [quantityRejected]
 * @property {number} [warehouseId]
 * @property {number} [locationId]
 * @property {string} [supplierBatchNumber]
 * @property {string} [packingSlipNumber]
 * @property {string} [inspectionStatus]
 * @property {string} [notes]
 */

const BASE_PATH = 'v1/PurchaseOrder';

export default function (instance) {
  return {
    getOrders(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getOrder(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    createOrder(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateOrder(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    sendOrder(id) {
      return instance.post(`${BASE_PATH}/${id}/send`);
    },

    cancelOrder(id) {
      return instance.post(`${BASE_PATH}/${id}/cancel`);
    },

    completeOrder(id) {
      return instance.post(`${BASE_PATH}/${id}/complete`);
    },

    // Lines
    getLines(orderId) {
      return instance.get(`${BASE_PATH}/${orderId}/lines`);
    },

    createLine(orderId, payload) {
      return instance.post(`${BASE_PATH}/${orderId}/lines`, payload);
    },

    updateLine(orderId, lineId, payload) {
      return instance.put(`${BASE_PATH}/${orderId}/lines/${lineId}`, payload);
    },

    deleteLine(orderId, lineId) {
      return instance.delete(`${BASE_PATH}/${orderId}/lines/${lineId}`);
    },

    // Receiving
    receiveLine(orderId, lineId, payload) {
      return instance.post(`${BASE_PATH}/${orderId}/lines/${lineId}/receive`, payload);
    },

    getReceipts(orderId, lineId) {
      return instance.get(`${BASE_PATH}/${orderId}/lines/${lineId}/receipts`);
    }
  };
}
